// Decimal hours → "8h 15m".
//
// Payroll and the policy card carry hours as decimals (8.25, 4.433333…)
// because the arithmetic needs them, but nobody reads a working day that way:
// 8.25 is "8h 15m", and "4.43h" leaves the reader working out whether .43 is
// 43 minutes. Every place that shows an hours figure to a person — the payroll
// View Details table, the hold / deduction breakdown, the attendance card's
// late-day rows — formats through here so they all read the same.
//
// Rounded to the minute. Whole hours drop the "0m" ("8h"), under an hour drops
// the "0h" ("45m"), and nothing at all is "0h" so an empty Hours cell still
// reads as a duration rather than a blank.
export function formatHoursMinutes(hours: number | string | null | undefined): string {
  const n = typeof hours === "string" ? parseFloat(hours) : Number(hours ?? 0);
  if (!Number.isFinite(n)) return "0h";
  const sign = n < 0 ? "-" : "";
  const totalMinutes = Math.round(Math.abs(n) * 60);
  const h = Math.floor(totalMinutes / 60);
  const m = totalMinutes % 60;
  if (h === 0 && m === 0) return "0h";
  if (m === 0) return `${sign}${h}h`;
  if (h === 0) return `${sign}${m}m`;
  return `${sign}${h}h ${m}m`;
}
